import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
export function CTABanner() {
  return <section id="contact" className="py-20 px-4 bg-primary relative overflow-hidden" data-id="element-16">
      {/* Modern gradient orbs */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-17">
        <div className="absolute -top-1/2 -right-1/4 w-[600px] h-[600px] rounded-full bg-white/5 blur-3xl" data-id="element-18" />
        <div className="absolute -bottom-1/2 -left-1/4 w-[500px] h-[500px] rounded-full bg-accent/10 blur-3xl" data-id="element-19" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-white/[0.03] blur-2xl" data-id="element-20" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-21">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-22">
          Ready to get your family member certified?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-23">
          Schedule a free consultation today to learn how your loved one can
          become a paid professional caregiver.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-24">
          <a href="tel:+18666528987" className="w-full sm:w-auto bg-accent hover:bg-[#b5955a] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg flex items-center justify-center gap-2" data-id="element-25">
            <PhoneIcon className="w-5 h-5" data-id="element-26" />
            Call Us Now
          </a>
          <a href="mailto:info@ambienthomecare.com" className="w-full sm:w-auto bg-transparent hover:bg-white/10 text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg transition-colors flex items-center justify-center" data-id="element-27">
            Request a Consultation
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-8 text-white/80 font-medium text-lg" data-id="element-28">
          Call us directly at{' '}
          <a href="tel:+18666528987" className="text-accent font-bold hover:underline" data-id="element-29">
            (866) 652-8987
          </a>
        </motion.p>
      </div>
    </section>;
}